import permissions from '../../data/permissions';

export default [
    {
        name: "SupplierGroupCreate",
        path: "supplier-group",
        component: () => import('./../../views/purchase/SupplierGroupCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_group.create }
    },
    {
        name: "SupplierGroupEdit",
        path: "supplier-group/:id/edit",
        component: () => import('./../../views/purchase/SupplierGroupEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_group.update }
    },
    {
        name: "SupplierGroupList",
        path: "supplier-groups",
        component: () => import('./../../views/purchase/SupplierGroupListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_group.index }

    },
    {
        name: "SupplierGroupDisplay",
        path: "supplier-group/:id",
        component: () => import('./../../views/purchase/SupplierGroupDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_group.read }
    }
]   